<template>
  <b-row align-h="center" class="services-wrapper">
    <b-col xl="6" md="6" sm="12">
      
      <b-card
          v-if="anyUpPrice"
          class="row services-list"
          header="Оновлення тарифів"
          header-tag="h5"
          border-variant="primary"
          style="margin-bottom: 10px;"
        >
          <div class="d-flex flex-column">
            <p class="mb-2">
              З <strong>{{ firstUpPriceDate }}</strong> тарифи на послугу <b>Інтернет</b> оновлено.
            </p>
            <b-button
              variant="outline-primary"
              href="https://everest24.com.ua/1406"
              target="_blank"
            >
              Деталі
            </b-button>
          </div>
        </b-card>

      <b-row class="services-list">
        <b-col
          class="services-list__item"
          v-for="(ls, idx) in lislLs"
          :key="`ls-${idx}`"
        >
        <div class="services-list__item-head">
          <!-- Left section: Contact info -->
          <div class="services-list__left">
            <div class="services-list__contact font-weight-bolder">
              {{ ls.info["contact_person"] }}
            </div>
            <div class="services-list__number font-weight-bolder">
              {{ ls.number }}
            </div>
          </div>

          <div class="services-list__info-item address-item" v-if="ls.info['address_title']">
            <i class="fas fa-map-marker-alt"></i>
            <span>{{ ls.info["address_title"] }}</span>
          </div>

          <!-- Right section: Additional info -->
          <div class="services-list__right">
            <div class="services-list__info-item" v-if="ls.info['mobile_phone']">
              <i class="fas fa-phone"></i>
              <span>{{ ls.info["mobile_phone"] }}</span>
            </div>
            <div class="services-list__info-item" v-if="ls.info['email']">
              <i class="fas fa-envelope"></i>
              <span>{{ ls.info["email"] }}</span>
            </div>
          </div>
        </div>

        <bonusSection 
          v-if="ls.info.bonus_amount" 
          :bonusAmount="ls.info.bonus_amount" 
          :shopLink="shopLink" 
        />


          <div class="services-list__item-body" ref="servicesList">
            <e-service-item
              v-for="(service, idx) in ls.info.services"
              class="services-item-w"
              :lsId="ls.number"
              :multitatiff="ls.info['user_multi_tariff']"
              :service="service"
              :info="ls.info"
              :key="`${ls.number}-service-${idx}`"
            />
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import serviceItem from "./../../components/servicesItem.vue";
import bonusSection from "../../components/bonusSection.vue";

export default {
  components: {
    "e-service-item": serviceItem,
    bonusSection
  },

  computed: {
    lislLs() {
      return this.$store.getters.getLsList || [];
    },

    shopLink() {
      // default shop
      let link = "https://club.everest24.com.ua/ua";

      for (const ls of this.lislLs) {
        const title = ls?.info?.address_title || "";

        if (title.includes("Хмельницький")) {
          link = "https://club-km.everest24.com.ua/ua";
          break;
        }
      }

      return link;
    },

    anyUpPrice() {
      return this.lislLs.some(ls => ls.info && ls.info.up_price);
    },

    firstUpPriceDate() {
      const found = this.lislLs.find(
        ls => ls.info && ls.info.up_price && ls.info.date_text
      );
      return found ? found.info.date_text : "";
    }
  }
};
</script>

<style lang="scss" scoped>
.services-list__item {
  padding: 20px 20px 0;
  margin-bottom: 20px;
  background: #ffffff4a;
  border-radius: 16px;
  -webkit-box-shadow: 0 23px 20px -20px rgba(6, 8, 10, 0.1),
    0 0 15px rgba(6, 8, 10, 0.06);
  box-shadow: 0 23px 20px -20px rgba(6, 8, 10, 0.1),
    0 0 15px rgba(6, 8, 10, 0.06);
  backdrop-filter: blur(14px);
  border: 1px solid #21252930;
  animation: slideUp 0.6s ease-out;
  min-width: 500px;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}


.services-list__item-head {
  padding-bottom: 10px;
  .ls-info {
  }
}

.services-item-w {
  margin-bottom: 20px;
}

@media (max-width: 768px) {
.services-list__item {
  background: none;
  border: none;
  box-shadow: none;
  min-width: 0;
}
.services-wrapper {
  margin-top: 70px;
}
}

.services-list__item-head {
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 8px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #0045ff3b;
  margin-bottom: 25px;
}



.services-list__left {
  display: flex;
  font-size: 20px;
}

.services-list__contact {
  color: #23165a;
}

.services-list__number {
  color: #4d7bff;
  margin-left: auto;
}

.services-list__right {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
}

.services-list__info-item {
  display: flex;
  place-self: center;
  align-items: center;
  font-size: 1rem;
  color: #424242;
  gap: 4px;
  font-weight: 500;
}

.address-item {
  align-items: center;
  font-size: 1rem;
  color: #424242;
  gap: 4px;
  font-weight: 500;
  border-bottom: 1px solid rgba(4, 0, 255, 0.2);
  border-top: 1px solid rgba(4, 0, 255, 0.2);
  padding: 10px 0;
  width: 100%;
  justify-content: center;
}

.services-list__info-item i {
  font-size: 0.9rem;
  color: #217bf373;
}
</style>
